import { connect } from 'react-redux';
import { selectAppLoaded } from '../../selectors/appState';
import { App } from './view';

const mapStateToProps = (state) => ({
  isAppLoaded: selectAppLoaded(state),
});

export const AppConnect = connect(mapStateToProps)(App);
